/** Photography generated from the standing brief in docs/IMAGE-SYSTEM.md. */
export const servicesHeroImage: { image: string; alt: string } = {
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/c18c5949-ded0-4124-b673-4de92164f4d8.jpg',
  alt: 'Five design materials arranged in a row on bone-coloured paper: a paint chip, type card, folded brochure, phone and swatch book',
}

export const servicePillarImages: Record<string, { image: string; alt: string }> = {
  '01': {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5a08a095-378b-4306-b4a8-2c320e944105.jpg',
    alt: 'An embossed geometric monogram card and muted colour swatches arranged on textured off-white paper',
  },
  '02': {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/003208fc-d400-4afd-be81-412b132aaf3a.jpg',
    alt: 'A laptop and phone showing the same abstract website layout on a pale oak desk',
  },
  '03': {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/a6654ad8-23b9-4776-95c2-4f398c481121.jpg',
    alt: 'A tablet showing an abstract analytics dashboard with a matte black stylus beside it',
  },
  '04': {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7d9df733-6ce4-4826-9184-2ee7e31cf29d.jpg',
    alt: 'A laptop with an abstract code editor beside a monitor showing a quiet browser layout in warm evening light',
  },
  '05': {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/38ea5517-6492-4a66-bebe-eb7b1ecda80d.jpg',
    alt: 'A printed analytics report with abstract charts and a black pen resting across it on a pale oak desk',
  },
}
